import BlackLogo from "./BlackLogo";
import GoldLogo from "./GoldLogo";
import GoldIcon from "./GoldIcon";
import WhiteLogo from "./WhiteLogo";
import EmptyIcon from "./EmptyIcon";
const Brand = {
  BlackLogo,
  GoldLogo,
  GoldIcon,
  WhiteLogo,
  EmptyIcon
};

export default Brand;
